import * as React from "react";
import { Dialog, type DialogProps } from "@/components/Dialog";
import { Form } from "@/components/Form";

export interface DialogFormProps extends Omit<DialogProps, "children" | "footerContent"> {
  formId?: string;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  primaryLabel?: string;
  secondaryLabel?: string;
  onCancel?: () => void;
  primaryVariant?: "primary" | "secondary" | "destructive" | "icon" | "link" | "unstyled" | "ghost";
  secondaryVariant?: "primary" | "secondary" | "destructive" | "icon" | "link" | "unstyled" | "ghost";
  children?: React.ReactNode;
}

export function DialogForm({
  formId = "dialog-form",
  onSubmit,
  primaryLabel = "Save",
  secondaryLabel = "Cancel",
  onCancel,
  primaryVariant,
  secondaryVariant = "secondary",
  children,
  title,
  ...dialogProps
}: DialogFormProps) {
  const handleFormSubmit = () => {
    // The form element itself will handle the submit event
    const form = document.getElementById(formId) as HTMLFormElement;
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <Dialog
      title={title}
      primaryAction={{
        label: primaryLabel,
        onPress: handleFormSubmit,
        variant: primaryVariant,
      }}
      secondaryAction={
        onCancel
          ? {
              label: secondaryLabel,
              onPress: onCancel,
              variant: secondaryVariant,
            }
          : undefined
      }
      {...dialogProps}
    >
      <Form id={formId} onSubmit={onSubmit}>
        {children}
      </Form>
    </Dialog>
  );
}
